import axiosInstance from "../../../api/axiosInstance";

export const fetchGrammarTopics = async (params) => {
 try {
 const cleaned = Object.fromEntries(
 Object.entries(params).filter(([, v]) => v !== "" && v != null)
 );
 const res = await axiosInstance.get("/public/grammar-topic", { params: cleaned });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const fetchGrammarTopicById = async (id) => {
 try {
 const res = await axiosInstance.get(`/public/grammar-topic/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const fetchGrammarSubTopicById = async (id) => {
 try {
 const res = await axiosInstance.get(`/public/grammar-topic/sub-topic/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};
